import styles from './Loader.module.scss';

const Loader: React.FC<React.PropsWithChildren<unknown>> = () => {
  return <div className={styles['loader']}></div>;
};

export default Loader;
